import { getFetchedDataPayload } from '@vista-digital/utilities';
import { seatingDomainStore } from '../../store';
export const getAreaCategoryById = (id) => {
    const areaCategory = getFetchedDataPayload(seatingDomainStore.data.areaCategories[id]);
    if (!areaCategory) {
        throw new Error(`Cannot find area category with ID ${id}.`);
    }
    return areaCategory;
};
//# sourceMappingURL=get-area-category-by-id.js.map